import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const Heading3 = ({ node }: RichTextContentProps) => {
  return (
    <h3>
      <RichTextContent node={node} />
    </h3>
  );
};

export default Heading3;
